export default "__VITE_ASSET__VbrcBeH6__"